import React from "react";
import logo from "./logo.png";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  AppBar,
  Avatar,
  Button,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { SystemContext } from "../../Theme";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

export const Navbar: React.FC = () => {
  const { user } = useAuth();
  const { systemName, toggleColorMode } = React.useContext(SystemContext);
  const theme = useTheme();

  return (
    <AppBar
      position="static"
      sx={{
        minWidth: "700px",
      }}
    >
      <Grid container height="40px">
        <Grid
          item
          xs={3}
          container
          justifyContent="flex-start"
          alignItems="center"
          columnSpacing={1}
          sx={{
            maxHeight: "40px",
          }}
        >
          <Grid item>
            <Avatar alt="Logo" src={logo} />
          </Grid>
          <Grid item>
            <Typography>{systemName}</Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={9}
          justifyContent="flex-end"
          alignItems="center"
          columnSpacing={1}
        >
          <Grid item>
              <Link
                    component={RouterLink}
                    style={{ color: "white", fontWeight: "bold" }}
                    to='https://drive.google.com/file/d/1hMvdefRu6klXP_noVHN2LtawRtHv6oJm/view'
                    target='_blank'
                  >
                    👉 User Guide
                  </Link>
          </Grid>
          <Grid item>
            <Tooltip title={`${theme.palette.mode} mode`}>
              <IconButton
                sx={{ ml: 1 }}
                onClick={toggleColorMode}
                color="inherit"
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Typography>
              Logged in as <b>{` ${user?.username}`}</b>
            </Typography>
          </Grid>
          <Grid item>
            <Button variant="contained" color="error">
              <Link
                underline="none"
                color="inherit"
                component={RouterLink}
                to="/logout"
              >
                Logout
              </Link>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
};
